module.exports = __webpack_public_path__ + "static/media/447772227_2598697303670363_4211085877776878281_n.471953fa.jpg";